import { motion } from "framer-motion";
import BSL4Map from "@/components/sections/BSL4Map";
import { BilingualEyebrow } from "@/components/ui/bilingual-heading";
import { useLanguage } from "@/contexts/LanguageContext";

const VNL_LOGO = "https://customer-assets.emergentagent.com/job_pandemic-ready/artifacts/5avj3ocx_PTE_vnl_logo.png";

export default function StrategicPositioning() {
  const { lang } = useLanguage();
  const labName = lang === "hu"
    ? "Pécsi Tudományegyetem — Virológiai Nemzeti Laboratórium"
    : "University of Pécs — National Laboratory of Virology";
  return (
    <section id="strategy" data-testid="strategy-section" className="py-20 md:py-28 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="mb-10">
          <BilingualEyebrow en="BSL-4 Laboratories in Europe" hu="BSL-4 laborat&oacute;riumok Eur&oacute;p&aacute;ban" className="text-[#9CA3AF]" />
          <h3 className="font-heading text-2xl md:text-3xl font-bold text-[#F3F4F6] tracking-tight">
            {labName}
          </h3>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <BSL4Map />
        </motion.div>

        {/* Context bar */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="mt-6 flex flex-col md:flex-row items-start md:items-center gap-5 p-5 border border-[#1F2937] bg-[#0A0F1A]/40"
        >
          <a href="https://vnl.pte.hu/en" target="_blank" rel="noopener noreferrer" className="shrink-0 hover:opacity-80 transition-opacity">
            <img src={VNL_LOGO} alt="University of Pécs National Laboratory of Virology" className="h-12 object-contain" loading="lazy" />
          </a>
          <p className="text-xs text-[#9CA3AF] leading-relaxed">
            {lang === "hu"
              ? "Pécs, Magyarország — a Pécsi Tudományegyetem Szentágothai János Kutatóközpontja (SZKK) keretein belül működő Virológiai Nemzeti Laboratórium (PTE VNL) Közép- és Kelet-Európa egyetlen, kutatási célokra dedikált, egyetemhez kapcsolódó BSL-4 kutatólaboratóriumát üzemelteti."
              : <>Located in P&eacute;cs, Hungary, within the University of P&eacute;cs Szent&aacute;gothai Research Centre (SZKK), the National Laboratory of Virology (PTE VNL) operates Central and Eastern Europe's only university-affiliated BSL-4 research laboratory dedicated to research purposes.</>}
          </p>
        </motion.div>
      </div>
    </section>
  );
}
